import { render, staticRenderFns } from "./probationModals.vue?vue&type=template&id=bb31902c&scoped=true&"
import script from "./probationModals.vue?vue&type=script&lang=js&"
export * from "./probationModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb31902c",
  null
  
)

export default component.exports